import '../vendor/modernizr';
import '../utils/jquery/lazy-bootstrap';
import '../expose_modules';

import 'jquery-ujs';
import 'raf';
